import React from "react";
import { Link } from "react-router-dom";
import { LegalPageLayout } from "../components/layout/LegalPageLayout";

const PrivacyPolicy: React.FC = () => {
  return (
    <LegalPageLayout
      title="Privacy Policy"
      description="How Setgo Innovations and Digistore Pay collect, use, and protect your personal information."
    >
      <h1 className="text-3xl font-bold text-secondary-900 mb-2">
        Privacy Policy
      </h1>
      <p className="text-secondary-600 text-sm mb-8">
        Last updated: January 2025. Setgo Innovations Private Limited (CIN:
        U85499KL2025PTC092559).
      </p>

      <section className="space-y-6 text-secondary-700">
        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            1. Introduction
          </h2>
          <p>
            Setgo Innovations Private Limited (“we”, “us”, “our”) operates
            Digistore Pay (Fintech), SetGo (Edutech), and Easy Jobs (Jobtech).
            We are committed to protecting your privacy. This policy explains how
            we collect, use, store, and share your information when you use our
            websites, apps, payment solutions, learning platforms, or
            job-matching services.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            2. Information We Collect
          </h2>
          <p className="mb-2">We may collect:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>
              <strong>Account & identity:</strong> Name, email, phone number,
              address, and government-issued ID when you register or use our
              services (e.g. Digistore Pay partner registration, SetGo learner
              accounts, Easy Jobs profile).
            </li>
            <li>
              <strong>Financial & transaction data:</strong> Payment details,
              transaction history, and business information for Digistore Pay
              and payment-related services, in line with applicable financial
              regulations.
            </li>
            <li>
              <strong>Usage data:</strong> How you use our platforms (pages
              visited, features used) to improve our products.
            </li>
            <li>
              <strong>Device & technical data:</strong> IP address, browser
              type, device information for security and compatibility.
            </li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            3. How We Use Your Information
          </h2>
          <p className="mb-2">We use your data to:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Provide, maintain, and improve Digistore Pay, SetGo, and Easy Jobs.</li>
            <li>Process payments and comply with financial and tax obligations.</li>
            <li>Verify identity and prevent fraud.</li>
            <li>Send service updates, support, and (with consent) marketing.</li>
            <li>Comply with Indian laws including RBI and data protection requirements.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            4. Sharing and Disclosure
          </h2>
          <p>
            We may share information with payment processors (e.g. Razorpay),
            banks, regulators, and service providers who assist our operations,
            under strict confidentiality. We do not sell your personal
            information. We may disclose data when required by law or to protect
            our rights and users’ safety.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            5. Data Security
          </h2>
          <p>
            We use industry-standard security measures to protect your data.
            Financial and sensitive data are encrypted. Access is limited to
            authorised personnel. We are headquartered in Kerala, India, and
            store data in compliance with applicable Indian regulations.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            6. Your Rights
          </h2>
          <p>
            You may request access, correction, or deletion of your personal
            data, subject to legal and contractual obligations. For Digistore
            Pay, SetGo, or Easy Jobs related requests, contact us at{" "}
            <a
              href="mailto:contact@setgo.in"
              className="text-primary-500 hover:underline"
            >
              contact@setgo.in
            </a>
            .
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            7. Cookies and Tracking
          </h2>
          <p>
            We use cookies and similar technologies for authentication,
            security, and analytics. You can manage cookie preferences in your
            browser. Essential cookies are required for our services to function
            properly.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            8. Changes and Contact
          </h2>
          <p>
            We may update this policy from time to time. Continued use of our
            services after changes constitutes acceptance. For questions:
            contact@setgo.in. Setgo Innovations Private Limited, CIN:
            U85499KL2025PTC092559, headquartered in Kerala, India.
          </p>
        </div>
      </section>

      <p className="mt-10 text-sm text-secondary-500">
        <Link to="/" className="text-primary-500 hover:underline">
          ← Back to home
        </Link>
      </p>
    </LegalPageLayout>
  );
};

export default PrivacyPolicy;
